import React from 'react';
import { motion } from 'framer-motion';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-[#FAF6EE] px-5 py-10 sm:py-16" data-id="element-181" data-mp="3krp1cty5kdl2">
      <div className="mx-auto max-w-5xl" data-id="element-182" data-mp="3fz5ndvvjzgfq">
        <div className="mx-auto max-w-2xl text-center" data-id="element-183" data-mp="3fy2w3mubjbza">
          <h2 className="font-display text-3xl font-bold leading-tight text-navy sm:text-4xl" data-id="element-184" data-mp="3b1487m19019j">
            What Teachers Are Saying.
          </h2>
          <p className="mt-3 text-sm text-navy/60 sm:text-base" data-id="element-185" data-mp="370ajwrjw8kg4">
            Feedback from Art teachers around the world
          </p>
        </div>
        <div className="mt-7 grid gap-4 sm:mt-9 sm:gap-6 md:grid-cols-3" data-id="element-186" data-mp="2x09x2vmtfm76">
          {testimonials.map((testimonial, index) => <motion.article key={testimonial.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: index % 3 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex h-full flex-col rounded-2xl bg-[#F1E9DA] p-6 sm:p-8" data-id="element-187" data-mp="2s2rxvwylolcd" data-mpi={index}>
              <p className="font-display text-lg italic leading-snug text-navy sm:text-xl" data-id="element-188" data-mp="m6chw021it38">
                “{testimonial.text}”
              </p>
              <div className="mt-auto pt-5" data-id="element-189" data-mp="c6bvg58vjwut">
                <div className="mb-3 h-px w-10 bg-gold/70" aria-hidden="true" data-id="element-190" data-mp="c73r1g2h1ul3" />
                <p className="text-sm font-bold text-navy" data-id="element-191" data-mp="zxr1a7zv0wat">{testimonial.name}</p>
                <p className="mt-0.5 text-xs text-navy/55" data-id="element-192" data-mp="14vskcsxacvma">{testimonial.location}</p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}